import { createClient } from '@supabase/supabase-js';

// TODO: Replace with your ANON (PUBLIC) key from Supabase dashboard
// IMPORTANT: Use the anon/public key (starts with eyJ...), NOT the service_role secret key
// The anon key is safe to use in browser code and respects Row Level Security (RLS)
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://cwansovuwwtktwvpmlxx.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_xDA8DEQSJTNu58oJcx1tDg_elcLnj00';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
